import { RevenuePrices } from "./RevenuePrices";

/**Build out the initial revenue price page */
export const BuildRevenuePricePage = () =>
{
	let priceApp = new RevenuePrices();

	priceApp.Initialize("revenuePricesPanelId");
};